// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgVisibilityOffIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M22.866 12.504A19.5 19.5 0 0 1 20.197 16l-3.269-3.266q.06-.362.07-.729A4.99 4.99 0 0 0 12 7.011a5 5 0 0 0-.69.07L8.831 4.604A9.2 9.2 0 0 1 12 4.014c6.508 0 10.686 7.192 10.866 7.491a1 1 0 0 1 0 1m-2.16 6.782a1 1 0 0 1-.325 1.637 1 1 0 0 1-1.094-.218l-2.209-2.218A9.75 9.75 0 0 1 12 19.995c-6.508 0-10.686-7.191-10.866-7.49a1 1 0 0 1 0-1 19.3 19.3 0 0 1 4.138-4.814L3.273 4.694a.999.999 0 1 1 1.44-1.389zM14.71 16.15l-1.46-1.458a2.9 2.9 0 0 1-1.249.31 3 3 0 0 1-2.999-2.997c.004-.444.11-.882.31-1.279l-1.46-1.458a4.87 4.87 0 0 0-.85 2.737A4.99 4.99 0 0 0 12 16.999a4.9 4.9 0 0 0 2.739-.849z"
    />
  </g>
);
export default SvgVisibilityOffIcon;
SvgVisibilityOffIcon.displayName = 'SvgVisibilityOffIcon';
